/**
 * Duración legible.
 *
 * El tiempo de lectura llega en segundos y en segundos no dice nada: «4.812 s»
 * obliga a dividir mentalmente. Lo que interesa es el orden de magnitud —si
 * alguien pasó minutos u horas—, no el segundo exacto.
 */
export function duracionLegible(segundos: number): string {
  if (segundos < 60) return `${Math.round(segundos)} s`;

  const minutos = Math.floor(segundos / 60);
  if (minutos < 60) return `${minutos} min`;

  const horas = Math.floor(minutos / 60);
  const resto = minutos % 60;
  return resto === 0 ? `${horas} h` : `${horas} h ${resto} min`;
}

/**
 * Formateador para campos que son **días**, no instantes.
 *
 * La vigencia de un normativo es un día del calendario. Si se formatea con el
 * huso del navegador, la medianoche UTC que manda la API se renderiza como el
 * día anterior en cualquier huso al oeste — y un documento que vence el 31 de
 * diciembre aparece venciendo el 30.
 */
export function formateadorDeDia(idioma: string, estilo: 'short' | 'medium' = 'medium') {
  return new Intl.DateTimeFormat(idioma, { dateStyle: estilo, timeZone: 'UTC' });
}
